interface Props {
  displayName: string;
  avatarEmoji: string;
  level: number;
  xpIntoLevel: number;
  xpForNextLevel: number;
  todayEnergy: number;
}

export function ProfileCard({ displayName, avatarEmoji, level, xpIntoLevel, xpForNextLevel, todayEnergy }: Props) {
  const pct = Math.min(100, Math.round((xpIntoLevel / xpForNextLevel) * 100));

  return (
    <div className="flex gap-4 rounded-xl border border-border-soft bg-bg-raised p-4">
      <Avatar emoji={avatarEmoji} />
      <div className="flex flex-1 flex-col justify-between">
        <div className="flex items-center gap-2">
          <span className="text-base">⚔️</span>
          <span className="text-lg font-semibold text-neutral-100">{displayName}</span>
          <span className="font-pixel text-[10px] text-brand-400">— Lv {level}</span>
        </div>

        <div className="mt-2 space-y-1">
          <div className="h-3 overflow-hidden rounded-full bg-bg-elevated">
            <div
              className="h-full rounded-full bg-xp-bar transition-all"
              style={{ width: `${pct}%` }}
            />
          </div>
          <div className="flex justify-between text-[11px] text-neutral-400">
            <span>XP</span>
            <span className="font-pixel">{xpIntoLevel} / {xpForNextLevel}</span>
          </div>
        </div>

        <div className="mt-2 flex items-center gap-2 text-xs text-time-400">
          <span>⚡</span>
          <span>bugün kazanılan: <b className="font-pixel">{todayEnergy}</b> enerji</span>
        </div>
      </div>
    </div>
  );
}

function Avatar({ emoji }: { emoji: string }) {
  return (
    <div
      className="flex h-20 w-20 shrink-0 items-center justify-center rounded-lg border-2 border-brand-500/60 bg-gradient-to-br from-brand-600 to-bg-elevated"
      style={{ imageRendering: 'pixelated' }}
    >
      <span className="text-4xl">{emoji}</span>
    </div>
  );
}
